/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2022
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "從右向左",
		"timeZoneID": "時區",
		"skin": "樣式",
		"metricsFileImportTask": "從檔案重新匯入",
		"displayMode": "預設視圖",
		"credentialRenewed": "已使用您的現行使用者 ID 和密碼更新您的認證。",
		"productLocale": "產品語言",
		"toggleDisabled": "關閉",
		"credentialChange": "更新",
		"log_level_Debug": "除錯",
		"confirmNewPassword": "確認新密碼",
		"unsavedViewMsg2": "如果您未先儲存變更，變更將會遺失。",
		"supportPortalErrorMessage": "請重試。如果問題持續發生，請聯絡管理者。",
		"legalText": "Licensed Materials - Property of IBM Corp. © Copyright IBM Corporation and other(s) 2005, %{year}. IBM、IBM 標誌、ibm.com 及 Cognos 是 International Business Machines Corp. 的商標或註冊商標，已在全球許多國家/地區或司法管轄區註冊。最新的 IBM 商標清單可於下列網頁上取得，網址為 www.ibm.com/legal/copytrade.shtml。本「程式」係依檢附於本「程式」之授權合約條款而為授權。此授權合約可能位於本「程式」目錄資料夾或識別為 \"License\" 或 \"Non_IBM_License\" 的檔案庫中（如果適用），或以書面授權合約提供。使用本「程式」前，請仔細閱讀本合約。使用本「程式」即表示您同意這些條款。",
		"groupsAndRoles": "群組和角色",
		"metricsMaintenanceTask": "新的維護",
		"email": "電子郵件",
		"contextual": "環境定義",
		"resetHome": "重設為預設值",
		"ltr": "從左向右",
		"credentials": "認證",
		"logging_congfig_title": "記載",
		"changePasswordTitle": "變更密碼",
		"format": "報告格式",
		"showUnread": "顯示未讀",
		"AILearning_active": "人工智慧學習位於：",
		"docsErrorMessage": "請重試。如果問題持續發生，請聯絡管理者。",
		"toggleEnabled": "開啟",
		"homeSetError": "設定預設的首頁時發生錯誤，請嘗試關閉並重新開啟此視圖。",
		"passwordChange": "變更密碼",
		"profile": "設定檔",
		"pdfRestricted": "PDF（受限）",
		"drillThrough": "重複逐層分析定義",
		"homeSet": "已順利設定您的首頁",
		"regionalOptions": "地區選項",
		"myPreferences": "我的喜好設定",
		"defaultHome": "預設",
		"version": "版本",
		"controller": "Controller",
		"manage": "管理",
		"biDirectionalFeaturesEnabled": "雙向語言支援",
		"newFeaturesErrorTitle": "新增特性的鏈結無法運作",
		"passwordMatch": "密碼相符",
		"updateProfileAndsettings": "更新設定檔和設定",
		"dashboardConsole": "工作區",
		"legacyAppsSlideoutLabel": "可用的舊式應用程式",
		"logging_config_description": "記載是用來進行疑難排解。請洽詢您的管理者，以取得設定的相關指引。",
		"confirmDeletion": "確認刪除",
		"signInButtonText": "登入",
		"dataSourceCredentials": "資料伺服器認證",
		"AILearningConfigurationSlideoutAllyLabel": "人工智慧學習配置",
		"loadingSettings": "載入設定",
		"spreadsheetMLRestricted": "Excel（受限）",
		"manageAILearning": "人工智慧學習",
		"xlsxDataRestricted": "Excel 資料（受限）",
		"advanced": "進階選項",
		"ok": "確定",
		"changeEmail": "變更",
		"showHints": "顯示提示",
		"general": "一般",
		"xlsxData": "Excel 資料",
		"newPassword": "新密碼",
		"hideAll": "全部隱藏",
		"confirmPassword": "確認密碼",
		"AILearning_config_description": "透過允許 Cognos Analytics 瞭解您的用法來改善產品內的建議。",
		"metricStudio": "Studio",
		"supportPortalErrorTitle": "「支援入口網站」的鏈結不作用",
		"log_level_Warn": "警告",
		"contentSettings": "內容設定",
		"setHomeButton": "集",
		"myCapabilities": "我的功能",
		"homePage": "首頁",
		"helpErrorMessage": "請重試。如果問題持續發生，請聯絡管理者。",
		"loadingProfile": "載入設定檔",
		"portal": "入口網站",
		"metricsPackage": "新的套件",
		"myCredentials": "我的認證",
		"myApiKeys": "我的 API 金鑰",
		"credentialCreate": "建立",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "無法更新密碼",
		"showHiddenObjects": "顯示隱藏的項目",
		"csv": "CSV",
		"docsErrorTitle": "說明文件的鏈結不作用",
		"log_level_Error": "錯誤",
		"wrongPassword": "無法鑑別",
		"productName": "IBM Cognos Analytics with Watson %{version}",
		"log_level_Info": "資訊",
		"welcomeBanner": "歡迎使用橫幅",
		"helpErrorTitle": "說明的鏈結不作用",
		"contentLocale": "內容語言",
		"pdf": "PDF",
		"oldPassword": "舊密碼",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "協助工具特性",
		"manageLogging": "記載",
		"loggingConfigurationSlideoutA11yLabel": "記載配置",
		"communityErrorTitle": "「社群」的鏈結不作用",
		"companionApps": "隨附應用程式",
		"setHomeLabel": "設定起始目錄為（現行視圖）",
		"metricsExportTask": "重新匯出",
		"csvRestricted": "CSV（受限）",
		"newFeaturesErrorMessage": "請重試。如果問題持續發生，請聯絡管理者。",
		"contributor": "Contributor",
		"showAll": "全部顯示",
		"logging_active": "記載是開啟的：",
		"html": "HTML",
		"profileAndSettings": "設定檔和設定",
		"baseTextDirection": "文字的基準方向",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "密碼",
		"invalidEmail": "輸入有效的電子郵件位址",
		"credentialCreateSuccess": "您已順利建立認證",
		"settings": "設定",
		"restrictedFormatSelected": "您沒有能力以此格式執行報告，但您可以存取以此格式儲存的報告。",
		"usageDataDeletionConfirmation": "刪除用法資料會重設人工智慧學習。您確定要刪除用法資料嗎？",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "檢視詳細資料",
		"deleteUsageData": "刪除用法資料：",
		"showPassword": "顯示密碼",
		"AILearning_config_title": "人工智慧學習",
		"myPreferencesSlideoutLabel": "設定檔和設定",
		"passWordChangeSuccess": "您已順利變更密碼",
		"logging_level": "記載層次：",
		"analysisStudio": "Analysis Studio",
		"communityErrorMessage": "請重試。如果問題持續發生，請聯絡管理者。",
		"cancel": "取消",
		"shareSetError": "關閉並重新開啟此視圖之前，無法執行此動作。",
		"passwordNotMatch": "糟了，密碼不符",
		"xml": "XML",
		"xmlRestricted": "XML（受限）",
		"openMenu": "開啟功能表",
		"closeMenu": '關閉功能表'
});